module.exports = __webpack_public_path__ + "static/web-5-22bd8770f616bb5fe7231ad2726e1fbc.mp4";